export default {
  bind(el, binding) {
    const { value: loadMore } = binding;
    if (typeof loadMore === "function") {
      let lastScrollTop = 0;
      el.addEventListener("scroll", event => {
        const { scrollTop, clientHeight, scrollHeight } = event.target;
        if (scrollTop>lastScrollTop && scrollTop + clientHeight >= scrollHeight - 2) {
          loadMore();
        }
        lastScrollTop = scrollTop; 
      });
    }
  }
};
